// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"a67ab704","176":"b3f9bc07"}[chunkId] + ".chunk.js";
};